/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import {
  GeneralModal,
  CustomTextField,
  OutlinedButton,
  ContainedButton,
  EmployeeBadge,
  ModalButton,
  MultiSelect,
} from '../index';
import { Typography, Grid } from '@mui/material';
import { useState } from 'react';

export const DepartmentModal = (props) => {
  const [editMode, setEditMode] = useState(false);

  return (
    <GeneralModal
      open={props.open}
      onClose={props.onClose}
      style={{ width: '65%', p: 0, overflow: 'hidden' }}
    >
      <Grid container>
        <Grid
          item
          xs={4}
          sx={{
            bgcolor: '#1A202C',
            p: 4,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography
            sx={{
              lineHeight: '1',
              fontWeight: 500,
              textTransform: 'uppercase',
              fontSize: '20px',
            }}
            margin={0}
            variant="subtitle1"
            align="center"
          >
            Details
          </Typography>
          <CustomTextField
            defaultValue={props.deptname}
            label="Department Name"
            disabled={!editMode}
            onChange={props.deptNameOnChange}
          />
          <CustomTextField
            multiline={true}
            defaultValue={props.deptdesc}
            label="Department Description"
            disabled={!editMode}
            onChange={props.deptDescOnChange}
          />
          <CustomTextField
            multiline={true}
            defaultValue={props.mandaworkdesc}
            label="Mandatory Work Description"
            disabled={!editMode}
            onChange={props.mandaWorkDescOnChange}
          />
          <CustomTextField
            defaultValue={props.location}
            disabled={!editMode}
            label="Location"
            onChange={props.locationOnChange}
          />
          <CustomTextField
            defaultValue={props.deptmanager}
            disabled={!editMode}
            label="Manager"
            style={{ mb: 3 }}
          />
          {!editMode ? (
            <OutlinedButton
              fullWidth={true}
              style={{ mt: 'auto' }}
              btnTitle="Edit Information"
              onClick={() => setEditMode(true)}
            />
          ) : (
            <ContainedButton
              fullWidth={true}
              btnTitle="Delete Department"
              onClick={props.handleConfirmDelete}
              style={{
                mt: 'auto',
                width: '100%',
                bgcolor: '#d5615d',
                border: '1px solid #d5615d',
                '&:hover': {
                  bgcolor: 'rgb(173, 59, 55) !important',
                  borderColor: 'rgb(173, 59, 55)',
                },
              }}
            />
          )}
        </Grid>
        <Grid item xs={8} sx={{ p: 4 }}>
          <Grid container direction="column" sx={{ height: '100%' }}>
            <Typography
              sx={{
                lineHeight: '1',
                fontWeight: 500,
                textTransform: 'uppercase',
                fontSize: '20px',
              }}
              margin={0}
              variant="subtitle1"
              align="center"
            >
              Members
            </Typography>
            <MultiSelect
              value={props.employeeName}
              onChange={props.handleSelectMembersChange}
              label="New Members"
              items={props.employees}
              itemName={props.employeeName}
              // required={true}
            />
            <Grid container spacing={2} sx={{ mt: 0 }}>
              {props.members.map((member, index) => (
                <EmployeeBadge
                  key={index}
                  name={`${member.firstname} ${member.lastname}`}
                  jobTitle={'Developer'}
                  removeIcon={true}
                />
              ))}
            </Grid>
            <Grid item>
              <Typography
                sx={{
                  lineHeight: '1',
                  fontWeight: 500,
                  textTransform: 'uppercase',
                  fontSize: '20px',
                  mt: 4,
                }}
                margin={0}
                variant="subtitle1"
                align="center"
              >
                Message
              </Typography>
              <CustomTextField
                defaultValue={props.messaging}
                multiline={true}
                label="Message"
                onChange={props.messagingOnChange}
              />
            </Grid>

            <ModalButton
              style={{ mt: 'auto' }}
              primaryBtnName="Save"
              secondaryBtnName="Cancel"
              primaryClickHandler={props.primaryClickHandler}
              secondaryClickHandler={() => {
                setEditMode(false);
                props.secondaryClickHandler();
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </GeneralModal>
  );
};
